import type { ElMessageBoxOptions, MessageOptions, } from "element-plus"
import { ElMessage, ElMessageBox, } from "element-plus"
import { noop, } from "lodash-es"
import "element-plus/es/components/message-box/style/index"

export function MessageBox(message: string, options?: ElMessageBoxOptions,) {
  const type = options?.type || "warning"
  const title = options?.title || "提示"
  const formatOptions: ElMessageBoxOptions = {
    title,
    type,
    message,
    draggable: true,
    lockScroll: true,
    showCancelButton: true,
    closeOnClickModal: false,
    ...options,
  }
  return ElMessageBox(formatOptions,).catch(noop,)
}

/**  */
export function showMessage(message?: string, type: "error" | "primary" | "success" | "warning" | "info" = "success", options?: MessageOptions,) {
  ElMessage({
    message,
    type,
    placement: options?.placement || "top",
    offset: 300,
    ...options,
  },)
}
